
import React, {useEffect, useState, useCallback} from 'react';
import {
    Box,
    TableContainer, Button,
    Table, TableBody, TableRow, TableCell, Grid, TableHead, Typography
} from '@material-ui/core';

import DateHelper from '@helper/DateHelper'
import MeasureService from '@user-service/MeasureService'

import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import DataUsageIcon from '@material-ui/icons/DataUsage';

import {makeStyles} from "@material-ui/core/styles";
import clsx from 'clsx';
import AuthProvider from "../../provider/AuthProvider";

const Moment = require('moment-timezone');
const Logs = (props) => {
    const classes = useStyles();
    const showHeader = !props.hideHeader
    const [profileID] = useState(props.profileID)
    const [week, setWeek] = useState(DateHelper.getWeek())
    const [logs, setLogs] = useState([])
    const [selectDate, setSelectDate] = useState(DateHelper.now('YYYY-MM-DD'))
    
    const handleDate = (selectDate) => {
        setSelectDate(selectDate)
    }
    
    const fetch = useCallback(async (selectDate) => {
        const logs = profileID  
          ? await MeasureService.getMeasureLogWithProfileID(selectDate, profileID)
          : await MeasureService.getMeasureLog(selectDate)
          
        setLogs(logs)
    },[])
    
    useEffect(()=>{
        fetch(selectDate).then()
    },[selectDate])

    
    useEffect(()=>{
        fetch(selectDate).then()
    },[week])


    if(!logs){ return <></> }

    return (
        <div id="cont-wrap" className={AuthProvider.isAppMode() ? 'app' : ''}>
            {showHeader &&
            <div className="sv">
                <div>
                    <h3>뇌기능 측정</h3>
                    <span>BRHW의 측정 및 운동 기록을 보여줍니다</span>
                    <i>Brain Health</i>
                </div>
            </div>
            }
            <div className="cont">
                <Grid container>
                    <Grid item xs={12}>
                        <Grid container spacing={1} justify={'center'} alignItems={'center'}>
                            <Grid item>
                                <IconButton 
                                    aria-label={'prev'} 
                                    className={classes.iconButton}
                                    onClick={async () => {
                                        const date = Moment(week[0].fullDate).add(-1, 'day')
                                        setWeek(DateHelper.getWeek(date)) 
                                    }}
                                >
                                    <ArrowBackIosIcon fontSize={'small'} />
                                </IconButton>
                            </Grid>
                            <Grid item> <Typography variant={'h5'}>{week[0].month}월</Typography></Grid>
                            <Grid item> 
                                <Typography style={{marginTop:5}} component={'span'} variant={'subtitle1'}>{week[0].date}일</Typography>
                                ~
                                <Typography style={{marginTop:5}} component={'span'} variant={'subtitle1'}>{week[6].date}일</Typography>
                            </Grid>
                            
                            <Grid item>
                                <IconButton
                                    aria-label={'prev'}
                                    onClick={async () => {
                                        const date = Moment(week[6].fullDate).add(+1, 'day')
                                        setWeek(DateHelper.getWeek(date))
                                    }}
                                >
                                    <ArrowForwardIosIcon fontSize={'small'}  />
                                </IconButton>
                            </Grid>
                        </Grid>
                        
                        <Box mb={5} mt={5}>
                            <Grid container spacing={1} style={{width: '100%', backgroundColor: '#fafafc', borderRadius: 15}}>
                            {week.map((values) => {
                                const { week, date, fullDate} = values
                                return (
                                    <Grid item 
                                      className={classes.date}
                                      key={fullDate}
                                      style={{width: '14.2%', textAlign: 'center'}}
                                    >
                                        <Button
                                            fullWidth    
                                            onClick={()=>{
                                            handleDate(values.fullDate)
                                        }}>
                                            <div>
                                                <span style={{color: '#aaa'}}>{week}</span>
                                                <div className={clsx('dateButton',{
                                                    ['active'] : selectDate === fullDate
                                                })}>{date}</div>
                                            </div>
                                        </Button>
                                    </Grid>
                                )
                            })}
                            </Grid>
                        </Box>
                        
                        <TableContainer>
                            <Table  aria-label="caption table" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell>측정운동</TableCell>
                                        <TableCell>시작시간</TableCell>
                                        <TableCell>설정시간</TableCell>
                                        <TableCell>측정시간</TableCell>
                                        <TableCell>Best Wave</TableCell>
                                        <TableCell>최적화율</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody className={classes.tableBody}>
                                    {logs.map((log, index) => {
                                        switch(log.hzType){
                                            case 'meditation':
                                            case 'meditationHeal':
                                            case 'intoSleep':
                                            case 'measureBandTest':
                                                return <RenderMeditationTable key={index} classes={classes} log={log}/>
                                            case 'default':
                                            case 'eeg':
                                            case 'meditationTest':
                                                return <RenderMeasureTable key={index} classes={classes} log={log}/>
                                            default:
                                                return <RenderTable key={index} classes={classes} log={log}/>
                                        }
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
              
            </div>
        </div>
    );
}

export function RenderMeditationTable(props){
    const {log , classes} = props

    const program = log.program
    const { image, name } =  program

    let lastTime, lastBestWave, lastRate
    
    lastTime = log.timeCount
    if(log.MM) lastTime += log.MM.timeCount
    if(log.MB) lastTime += log.MB.timeCount
    lastTime = DateHelper.secToFormat(lastTime)

    lastBestWave = parseInt(log.bestWave)
    if(log.MM) lastBestWave += parseInt(log.MM.bestWave)
    if(log.MB) lastBestWave += parseInt(log.MB.bestWave)
    
    lastRate = parseInt(log.resultRate)
    if(log.MM) lastRate += parseInt(log.MM.resultRate)
    if(log.MB) lastRate += parseInt(log.MB.resultRate)
    
    return (
        <React.Fragment>
            <TableRow>
                <TableCell>
                    <Box className={classes.exerciseBox}>
                        <Grid container>
                            <Grid item className={'image'}>
                                {(image && '' !== image) &&
                                <img
                                    className={classes.image}
                                    src={require(`@images/${image}`)}
                                    alt={name}
                                />
                                }
                            </Grid>
                            <Grid item>
                                <div className={'title'}>{name}</div>
                                <div>
                                    {log.measureName}
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </TableCell>
                <TableCell className={'sub'}>{DateHelper.format(log.createdAt,'YY년 MM월 DD일 HH시mm분')}</TableCell>
                <TableCell className={'sub'}>
                    <div>{log.measureCode}</div>
                    <div>MM</div>
                    <div>MB</div>
                    <div>&nbsp;</div>
                </TableCell>
                <TableCell>
                    <div>{DateHelper.secToFormat(log.timeCount)}</div>
                    <div>
                        {(log.MM && log.MM.timeCountText) 
                            ? `${DateHelper.secToFormat(log.MM.timeCount)}` 
                            : <span className={'sub'}>없음</span>}
                    </div>
                    <div>
                        {(log.MB && log.MB.timeCountText)
                            ? `${DateHelper.secToFormat(log.MB.timeCount)}`
                            : <span className={'sub'}>없음</span>}
                    </div>
                    <Box mt={2}><b>{lastTime}</b></Box>
                </TableCell>
                <TableCell>
                    <div>{log.bestWave} W</div>
                    <div>
                        {(log.MM && log.MM.bestWave) 
                            ? `${log.MM.bestWave} W` 
                            : <span className={'sub'}>없음</span>}
                    </div>
                    <div>
                        {(log.MB && log.MB.bestWave) 
                            ? `${log.MB.bestWave} W` 
                            : <span className={'sub'}>없음</span>}
                    </div>
                    <Box mt={2}><b>{lastBestWave} W</b></Box>
                </TableCell>
                <TableCell>
                    <div>{log.resultRate} W</div>
                    <div>
                        {(log.MM && log.MM.resultRate) 
                            ? `${log.MM.resultRate} W` 
                            : <span className={'sub'}>없음</span>}
                    </div>
                    <div>
                        {(log.MB && log.MB.resultRate) 
                        ? `${log.MB.resultRate} W` 
                        : <span className={'sub'}>없음</span>}
                    </div>
                    <Box mt={2}><b>{lastRate} W</b></Box>
                </TableCell>
            </TableRow>
        </React.Fragment>
    )
}


export function RenderTable(props){
    const {log , classes} = props
    
    const program = log.program
    const { image, name } =  program

    const resultVar = log.resultVar
    
    if( 'default' === log.hzType){
        if('10' !== log.measureTypeCode){
            return <></>
        }
    }
    return (
        <TableRow>
            <TableCell>
                <Box className={classes.exerciseBox}>
                    <Grid container>
                        <Grid item className={'image'}>
                            {(image && '' !== image) &&
                            <img
                                className={classes.image}
                                src={require(`@images/${image}`)}
                                alt={name}
                            />
                            }
                        </Grid>
                        <Grid item>
                            <div className={'title'}>{name}</div>
                            {'measure' !== log.programType &&
                            <div>{log.measureName} - {log.measureCode} </div>
                            }
                        </Grid>
                    </Grid>
                </Box>
            </TableCell>
            <TableCell className={'sub'}>{DateHelper.format(log.createdAt,'YY년 MM월 DD일 HH시mm분')}</TableCell>
            <TableCell className={'sub'}>{log.measureTime}</TableCell>
            <TableCell>{(log.measureTime && parseInt(log.timeCount) > parseInt(log.measureTime) * 60) ? DateHelper.secToFormat(parseInt(log.measureTime) * 60) : log.timeCountText}</TableCell>
            <TableCell>{log.bestWave} W</TableCell>
            <TableCell>
                {log.resultRate} W
                {(resultVar && (-1 < resultVar.score)) &&
                <Box mt={1}>
                    점수: {resultVar.score}
                </Box>
                }
                
                {(resultVar && (-1 < resultVar.maxCount) ) &&
                <Box mt={1}>
                    이완율: {resultVar.maxCount * 10}%
                </Box>
                }
                
                {(resultVar && resultVar.synapse) &&
                <Box mt={1}>
                    <Grid container style={{width: 160, color:'white', backgroundColor: 'rgba(0,0,0,0.3)', padding: 10, borderRadius: 15}}>
                        <Grid item xs={6}>E: {resultVar.synapse.E} %</Grid>
                        <Grid item xs={6}>S: {resultVar.synapse.S} %</Grid>
                        <Grid item xs={6}>A: {resultVar.synapse.A} %</Grid>
                        <Grid item xs={6}>O: {resultVar.synapse.O} %</Grid>
                        <Grid item xs={6}>D: {resultVar.synapse.D} %</Grid>
                    </Grid>
                </Box>
                }
            </TableCell>
        </TableRow>
    )
}

export function RenderMeasureTable(props){
    const {log , classes} = props

    const program = log.program
    const { name } =  program
    
    if( 'default' === log.hzType){
        if('10' !== log.measureTypeCode){
            return <></>
        }
    }
    return (
        <TableRow>
            <TableCell>
                <Box className={classes.exerciseBox}>
                    <Grid container>
                        <Grid item className={'image'} style={{textAlign: 'center'}}>
                            <DataUsageIcon style={{
                                fontSize: '2rem',
                                color: '#999'
                            }} />
                        </Grid>
                        <Grid item>
                            <div className={'title'}>{name}</div>
                        </Grid>
                    </Grid>
                </Box>
            </TableCell>
            <TableCell className={'sub'}>{DateHelper.format(log.createdAt,'YY년 MM월 DD일 HH시mm분')}</TableCell>
            <TableCell className={'sub'}>{log.measureTime}</TableCell>
            <TableCell />
            <TableCell />
            <TableCell />
        </TableRow>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        padding: 30,
        margin: 'auto'
    },
    date: {
        '& .dateButton': {
          fontSize: 20, paddingTop: 8, fontWeight: 'bold', width: 50, height: 50, borderRadius: '50%'
        },
        '& .active': {
            backgroundColor: '#0156B8',
            color: 'white'
        }
    },
    
    tableBody: {
        '& .center': {
          textAlign: 'center'
        },
        '& .sub': {
            color: '#999',
        },
    },
    exerciseBox: {
        width: 300,
        padding: `18px 20px`,
        backgroundColor: '#F5F9FE',
        borderRadius: 30,
        
        '& .title': {
            fontSize: 20,
            fontWeight: 700,
        },
        '& .image': {
            marginRight: 20,
            width: 50,
        }
    },
    image : {
        width: 50
    }

}));

export default Logs
